import React from 'react'
import { Link } from 'gatsby'
import moment from 'moment'
import './style.scss'

class BookTemplateDetails extends React.Component {
  render() {
    const { subtitle, author } = this.props.data.site.siteMetadata
    const post = this.props.data.markdownRemark
  

    const homeBlock = (
      <div>
        <Link className="post-single__home-button" to="/books/">
          All Books
        </Link>
      </div>
    )

    return (
      <div>
        {homeBlock}
        <div className="post-single">
          <div className="post-single__inner">
            <h1 className="post-single__title">Book: {post.frontmatter.title}</h1>
            <div className="post-single__date">
              <em>
                Published {moment(post.frontmatter.date).format('D MMM YYYY')} by <a
                href={`https://twitter.com/${author.twitter}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>{author.name}</strong>
              </a>
              </em>
            </div>
            <div
              className="post-single__body"
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
            
          </div>
          <div className="post-single__footer">
            
            <hr />
            <p className="post-single__footer-text">
            We create <a href="https://fibery.io">Fibery</a> — work management platform that grows with your company. 
            Go see for yourself: <a href="https://fibery.io">https://fibery.io</a> 🎈
            </p>
           
            
          </div>
        </div>
      </div>
    )
  }
}

export default BookTemplateDetails
